export default __webpack_public_path__ + "static/media/product-3.25a60347.jpg";